export default function handleDesignStyle(isHero, asBackgroundDegrade, styles) {
  return isHero
    ? asBackgroundDegrade
      ? styles["_design"]
      : styles["_design_light"]
    : "";
}
